import { useLazyQuery } from "@apollo/client";
import { getSupportedProviders } from "_graphql/queries/suppliers";
import { verifyPayment } from "_graphql/queries/payment";
import {
  GetSupportedProviders,
  GetSupportedProvidersVariables,
} from "_graphql/queries/__generated__/GetSupportedProviders";
import {
  verifyAccountDetails as VerifyAccountDetailsType,
  verifyAccountDetailsVariables,
} from "_graphql/queries/__generated__/verifyAccountDetails";

export const usePaymentChannels = () => {
  const [getChannels, { data, error, loading }] = useLazyQuery<
    GetSupportedProviders,
    GetSupportedProvidersVariables
  >(getSupportedProviders);

  const [verifyAccount, { data: account, error: verifyError, loading: verifying }] =
    useLazyQuery<VerifyAccountDetailsType, verifyAccountDetailsVariables>(verifyPayment);

  return { getChannels, verifyAccount, account, verifying, loading, error, verifyError, data };
};